module.exports = __webpack_public_path__ + "static/media/dark-swap-double.c43280b4.svg";